<barcode-scanner-livestream type="upc" (valueChanges)="onValueChanges($event)" (started)="onStarted"></barcode-scanner-livestream>

<!--code_128-->
